import { Col, Container, Row } from "react-bootstrap";

const DataDisclaimerContent = () => {
  return (
    <section className="section bg-light">
      <Container>
        <Row className="justify-content-center mb-5">
          <Col md={8} lg={6} className="text-center">
            <h6 className="subtitle">
              Last update: <span className="fw-bold">March 30, 2025</span>
            </h6>
          </Col>
        </Row>
        <Row className="justify-content-flex-start mb-5">
          <Col md={12} lg={12} className="text-left">
            <p className="text">
              Please read this Data Disclaimer carefully before using the
              financial information provided by Equitix App ("the App").
            </p>
            <h5 className="mb-2 fs-18">1. Source of Information:</h5>
            <p className="text-muted">
              The financial data, stock information, news, and related financial
              content displayed in the Equitix App are sourced from Argaam. By
              using the App, you acknowledge and accept the following conditions
              regarding this data:
            </p>
          </Col>
          <Col md={12} lg={12} className="text-left">
            <h5 className="mb-2 fs-18">2. Data Accuracy and Timing:</h5>
            <p className="text-muted">
              a. <span className="fw-bold">Delayed Information:</span> Stock
              market data displayed in the App is delayed by 15 minutes from
              real-time market activities.
            </p>
            <p className="text-muted">
              b. <span className="fw-bold">Update Frequency:</span> Data is
              refreshed at 15-minute intervals throughout trading hours.
            </p>
            <p className="text-muted">
              c. <span className="fw-bold">No Guarantee:</span> While we strive
              to provide accurate and reliable information, Equitix does not
              guarantee the accuracy, completeness, timeliness, or sequence of
              any data displayed in the App.
            </p>
            <p className="text-muted">
              d. <span className="fw-bold">Technical Issues:</span> Data updates
              may occasionally be affected by technical issues, network delays,
              or source limitations beyond our control.
            </p>
          </Col>
          <Col md={12} lg={12} className="text-left">
            <h5 className="mb-2 fs-18">3. Use of Financial Information:</h5>
            <p className="text-muted">
              a. <span className="fw-bold">Informational Purpose Only:</span>{" "}
              All financial data, stock quotes, news, and analysis provided
              through the App are for informational purposes only and not
              intended as investment advice.
            </p>
            <p className="text-muted">
              b. <span className="fw-bold">No Recommendation:</span> The
              presence of any stock, financial instrument, or related
              information in the App does not constitute a recommendation to
              buy, sell, or hold any security.
            </p>
            <p className="text-muted">
              c. <span className="fw-bold">User Responsibility:</span> Users are
              solely responsible for verifying all information before making any
              investment decisions. You acknowledge that any trading or
              investment decisions are made at your own risk.
            </p>
            <p className="text-muted">
              d. <span className="fw-bold">Past Performance:</span> Historical
              data and past performance are not indicative of future results.
              Market conditions change constantly, and investments may lose
              value.
            </p>
          </Col>
          <Col md={12} lg={12} className="text-left">
            <h5 className="mb-2 fs-18">4. Third-Party Content:</h5>
            <p className="text-muted">
              Equitix bears no responsibility for any content provided by Argaam
              or other third-party sources. We do not endorse or verify the
              accuracy of third-party information displayed in the App.
            </p>
          </Col>
          <Col md={12} lg={12} className="text-left">
            <h5 className="mb-2 fs-18">5. Limitation of Liability:</h5>
            <p className="text-muted">
              To the maximum extent permitted by applicable law, Equitix shall
              not be liable for any direct, indirect, incidental, special,
              consequential, or exemplary damages resulting from:
            </p>
            <p className="text-muted">
              a. The use of or inability to access financial data through the
              App
            </p>
            <p className="text-muted">
              b. Any investment or trading decisions made based on information
              provided in the App
            </p>
            <p className="text-muted">
              c. Any errors, omissions, or inaccuracies in the data
            </p>
            <p className="text-muted">
              d. Delays, interruptions, or data unavailability
            </p>
          </Col>
          <Col md={12} lg={12} className="text-left">
            <p className="text-muted mt-4">
              By using the Equitix App, you acknowledge that you have read,
              understood, and agree to this Data Disclaimer.
            </p>
          </Col>
          <Col md={12} lg={12} className="mt-3 text-left">
            <h6 className="subtitle">
              For any questions regarding this Data Disclaimer, please contact
              us at <span className="text-primary">hello@codeforgeit.com</span>.
            </h6>
          </Col>
          <Col md={12} lg={12} className="mt-2 text-left">
            <p className="small text-muted">
              © 2025 Equitix - Product of CodeForge for Software Solutions
            </p>
          </Col>
        </Row>
      </Container>
    </section>
  );
};
export default DataDisclaimerContent;
